module.exports = __webpack_public_path__ + "static/media/business-philosophy-ad1.5c0b19d4.png";